<template>
  <div class="chat-widget">
    <section class="chat-app-window">
      <vue-perfect-scrollbar
        ref="refChatLogPS"
        :settings="perfectScrollbarSettings"
        class="user-chats scroll-area"
      >
        <div class="chats">
          <div
            v-for="(comentario, index) in comentarios"
            :key="comentario.contaId + String(index)"
            class="chat"
            :class="{
              'chat-left': comentario.contaId !== authUser.id,
            }"
          >
            <div class="chat-avatar">
              <b-avatar
                size="32"
                class="avatar-border-2 box-shadow-1"
              >
                <feather-icon :icon="getIcon(comentario.contaId)" />
              </b-avatar>
            </div>
            <div class="chat-body">
              <div class="chat-content">
                <b>{{ getConta(comentario.contaId) }} </b>
                <p>
                  {{ comentario.texto }}
                </p>
                <b-badge variant="primary">{{
                  comentario.dataHora | formatDatetime
                }}</b-badge>
              </div>
            </div>
          </div>
        </div>
      </vue-perfect-scrollbar>
      <validation-observer ref="regras">
        <b-form
          v-if="podeVotar"
          class="chat-app-form"
          @submit.prevent="onGravar"
        >
          <b-input-group class="input-group-merge form-send-message mr-1">
            <validation-provider
              name="Informe o Comentário"
              rules="required"
              class="w-100"
            >
              <b-form-input
                v-model="comentario.texto"
                name="comentário"
                placeholder="Digite seu comentário"
              />
            </validation-provider>
          </b-input-group>

          <b-button
            variant="primary"
            type="submit"
          >
            Enviar
          </b-button>
        </b-form>
      </validation-observer>
    </section>
  </div>
</template>

<script>
import {
  BFormInput, BAvatar, BInputGroup, BForm,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import AssembleiaAPI from '@/api/assembleia'

export default {
  name: 'ComentariosAssembleia',
  components: {
    ValidationProvider,
    ValidationObserver,
    VuePerfectScrollbar,
    BAvatar,
    BFormInput,
    BForm,
    BInputGroup,
  },
  props: {
    assembleia: Object,
    itemPauta: Object,
    podeVotar: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      perfectScrollbarSettings: {
        maxScrollbarLength: 150,
        wheelPropagation: false,
      },
      required,

      comentario: {
        texto: null,
      },
      comentarios: [],
    }
  },
  computed: {
    authUser() {
      const user = this.$store.getters['auth/authUser']()
      return user
    },
  },
  async created() {
    this.fetchComentarios()
  },
  methods: {
    fetchComentarios() {
      AssembleiaAPI.listComentario(this.assembleia.id, {
        itemPautaId: this.itemPauta && this.itemPauta.id,
      }).then(res => {
        this.comentarios = res.data.content
        setTimeout(() => {
          const container = this.$el.querySelector('.scroll-area')
          container.scrollTop = container.scrollHeight
        }, 0)
      })
    },
    getConta(contaId) {
      if (this.authUser.id === contaId) {
        return this.authUser.primeiroNome
      }
      if (contaId === 0) {
        return 'Informativo'
      }
      return contaId
      // eslint-disable-next-line
      //return this.$store.getters['empresa/getConta'](contaId).nome || '--'
    },
    getIcon(contaId) {
      if (this.authUser.id === contaId) {
        return 'UserIcon'
      }
      if (contaId === 0) {
        return 'CloudIcon'
      }
      return 'UsersIcon'
    },
    onGravar() {
      this.$refs.regras.validate().then(result => {
        if (result) {
          AssembleiaAPI.createComentario(this.assembleia.id, {
            ...this.comentario,
            itemPautaId: this.itemPauta && this.itemPauta.id,
          })
            .then(() => {
              this.comentario = {}
              this.showSuccess('Comentário gravado com sucesso.')
              this.fetchComentarios()
            })
            .catch(err => {
              this.showError(err)
            })
        }
      })
    },
    showError(err) {
      this.$toast.error(err.response ? err.response.data.error : err)
    },
    showSuccess(msg) {
      this.$toast.success(msg)
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/base/pages/app-chat.scss';
@import '@core/scss/base/pages/app-chat-list.scss';

.user-chats {
  background-color: white !important;
}
</style>
